module.exports = __webpack_public_path__ + "img/Flunder_15.ca8c66be.jpg";